import { ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import ArrowiOSBackward from "@store/Components/Icons/ArrowiOSBackward";
import ArrowiOSDownward from "@store/Components/Icons/ArrowiOSDownward";
import ArrowiOSForward from "@store/Components/Icons/ArrowiOSForward";
import ArrowiOSUpward from "@store/Components/Icons/ArrowiOSUpward";
import { scalableIconStyles, transitionControlStyles } from "@store/theme/mixins";
import { buttonResetProps } from "@store/theme/props/button";
import { css } from "styled-components";

export type CarouselArrowDirection = "top" | "right" | "bottom" | "left";

export const getCarouselArrowSrc = (direction: CarouselArrowDirection) => {
    switch (direction) {
        case "top":
            return ArrowiOSUpward;
        case "right":
            return ArrowiOSForward;
        case "bottom":
            return ArrowiOSDownward;
        case "left":
            return ArrowiOSBackward;
        default:
            return "";
    }
};

export const getCarouselArrowProps = (direction: CarouselArrowDirection): ButtonPresentationProps => ({
    variant: "primary",
    icon: {
        src: getCarouselArrowSrc(direction),
        position: "left",
    },
    css: css`
        ${props => props.theme?.button?.primary?.css}
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 0;
        min-width: 0;
        padding: 0;
        border: 0;
        font-size: 32px;
        width: 1em;
        height: 1em;

        ${IconWrapper} {
            ${scalableIconStyles("0.5em")}
            top: 0;
            margin: 0;
        }
    `,
});

export const dotWrapperStyles = () => {
    return css`
        display: flex;
        justify-content: center;
        width: 100%;
    `;
};

export const getDotButtonProps = (selected?: boolean, color = "inherit") => {
    return {
        ...buttonResetProps,
        css: css`
            ${buttonResetProps.css}
            color: ${getColor(color)};
            background-color: currentColor;
            width: 8px;
            height: 8px;
            margin-left: 8px;
            border-radius: 50%;
            transition: ${transitionControlStyles("color", "opacity")};
            ${!selected ? "opacity: 0.3;" : null}

            &:first-child {
                margin-left: 0;
            }

            &:hover,
            &:active {
                color: ${getColor(color)};
                background-color: currentColor;
                opacity: 1;
            }
        `,
    } as ButtonPresentationProps;
};
